
export const PathNames = {
  CREATE_EVENT_MODELS_PAGE: "/create-event-model",
  MANAGE_EVENT_MODELS_PAGE: "/manage-event-model",
  REPLAY_FAILED_EVENTS_PAGE: "/replay-failed-events"
}

export const CommonConstants = {
  PAGE_HEADER: "EASE Authoring",
  USER_AUTHORIZATION_TOKEN_KEY: "USER_AUTHORIZATION_TOKEN_KEY",
  MCM_URL_PREFIX: "https://mcm.amazon.com/cms/MCM",
  SSUI_LINK: "https://ssui.tellus.myhr.a2z.com/view",
  PRESENTATION_DETAIL: "presentationDetail",
  CONTENT_DETAILS: "contentDetails",
  HTTP_POST : "POST",
  AEM_STAGE_CREATE_CONTENTS_API : "https://author-afs-dev.adobecqms.net/etc/myhr/paths/create-contents.json",
}

export const Regex = {
  /**
   * Regex for extracting variable names out of a JSON Logic rule.
   * Example:
   * Rule: {"==": [{ "var": "country" }, "USA"]}
   * Matching the patterns below with the above rule returns an array: ['"var": "country"']
   */
  JSONLogicVariablePattern: /\"var\":\"([a-zA-Z]+)\"/g,
  EventNameInvalidCharRegex: /[/#%+\\.?]/,
  EmptyPTagRegex: /<p\s*>\s*<\/p>/g,
  EmptyBracesRegex: /\{\}/,
  InRuleRegex: /\{"in":\[(.*?)\]\}/g,
  EqualToRuleRegex: /\{"==":\[(.*?)\]\}/g,
  SpecialCharRegex: /[\[\],]/g,
}

export const APIPaths = {
  GetEventModels: "/api/v1/event-models",
  GetEventModel: "/api/v1/event-model",
  UpsertEventModel: "/api/v1/event-model",
  ExecuteEvents: "/api/v1/executeEvents",
  ViewAttributeRule: "/attributeRule/view",
  GetProcessedEvents: "/api/v1/processed-events/",
  RetryEvents: "/api/v1/retry-events",
  FetchContextAttributes: "/api/v1/fetchContextAttributes",
  UpsertDerivedSegmentationAttribute: "/api/v1/upsertDerivedSegmentationAttribute",
  PromoteDerivedSegmentationAttributes: "/api/v1/promoteDerivedSegmentationAttributes",
  InitiateMultipartUpload: "/assetsapiv1-createMultipartUpload",
  UploadFileToS3: "/assetsapiv1-uploadFileToS3",
  CompleteS3FileUpload: "/assetsapiv1-completeS3FileUpload",
  getTriggersAndSolutionTypes: "/api/v1/triggers-and-solution-types",
}

export const EASE_CLIENT_ID = "EASE";
export const PART_SIZE_5_MB = 5242880;
export const PRESENTATION_DETAIL_PREFIX = "presentationDetail.";
export const FILE_UPLOAD_REPORT_SUFFIX = "-fileReport.csv";
export const MAX_DERIVED_ATTRIBUTE_ENTITIES = 10000;

export const StringUtils = {
  COMMA_SEPARATOR: ",",
  CARRIAGE_RETURN: "\n",
  EMPTY: "",
  UNDERSCORE: "_",
  SLASH_DELIMITER: "/",
  DOT_SEPARATOR: "."

}
export const BulkFileUploadHeaders = {
  EMPLOYEE_ID: "employeeid",
  SITE_ID: "siteid",
  COMMENT: "comment",
  PUBLISH_UNPUBLISH: "publish/unpublish"
}
export const FileExtensions = {
  CSV: ".csv"
}
export const SolutionTypes = {
  CONTACT_ALERT: "Contact_Alert",
  MESSAGE_BOARD: "Message_Board",
  CONTACT_ALERT_REPORTING: "Contact_Alert_Reporting"
}
export const SolutionTypeNames = {
  BULK_FILE_UPLOAD: "bulkFileUpload",
  FILE_UPLOAD_REPORT: "fileUploadReport",
  IS_READ: "isRead"
}
export const overridePromoteToProdForSolutionTypes = [SolutionTypes.CONTACT_ALERT, SolutionTypes.MESSAGE_BOARD]
export const overrideRetireFromProdForSolutionTypes = [SolutionTypes.CONTACT_ALERT, SolutionTypes.MESSAGE_BOARD]
export const UpsertSegmentationDerivedAttributeOperationType = {
  CREATE: "CREATE",
  UPDATE: "UPDATE"
}

export const RetryConstants = {
  MAX_RETRIES: 3,
  RETRY_DELAY: 2000
}

export const ActionType = {
  CREATE: "CREATE",
  EDIT: "EDIT"
}

export const TimestampInputValidity = {
  VALID_FROM: "validFrom",
  VALID_TILL: "validTill"
}

export const ContextAttributesRegex = {
  MESSAGE_BOARD_READ_CMSID_REFERENCE: "\\$FetchEmployeeContext\\(([^,]+),\\s*(\\$\\{[^}]*\\}),\\s*([^)]+)\\)",
  MESSAGE_BOARD_READ_CMSID_VALUE: "\\$FetchEmployeeContext\\(([^,]+),\\s*([^)]+),\\s*([^)]+)\\)",
}

export const AttributeTypes = {
  FILE: "File",
  CHECKBOX: "Checkbox",
  LINK: "Link",
  MESSAGE_BOARD_CMS_ID_INPUT: "MessageBoardCmsIdInput",
  MESSAGE_BOARD_CONTEXT_ATTRIBUTE: "MessageBoardContextAttribute",
  RICH_TEXT: "RichText"
}

export const CUSTOM_ATTRIBUTE_TYPES = [AttributeTypes.FILE, AttributeTypes.CHECKBOX, AttributeTypes.LINK,
  AttributeTypes.MESSAGE_BOARD_CMS_ID_INPUT, AttributeTypes.MESSAGE_BOARD_CONTEXT_ATTRIBUTE, AttributeTypes.RICH_TEXT];

export const AUTO_DISMISS_TIMEOUT = 5000;
export const DISMISS = "Dismiss"
